import { Box, Center, VStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import Countdown from 'components/countdown';
import BlockRenderer from 'components/sanity-block-renderer';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const StyledCountdown = Countdown;

export const ModalInner = VStack.withConfig({
  backgroundColor: getDesignToken('background-default'),
  height: 'full',
  width: 'full',
  overflow: 'scroll',
});

export const PictureHeading = Box.withConfig({
  margin: '$8',
  flexGrow: 0,
  height: 'auto',
});

export const BodyContent = Box.withConfig({
  flexGrow: 1,
  position: 'relative',
  padding: '$4',
  _text: {
    color: primitive.$greyOne,
    textAlign: 'center',
  },
});

export const ShortCodeWrapper = Box.withConfig({
  alignSelf: 'center',
  backgroundColor: primitive.$bbqBrown,
  borderRadius: 'xl',
  shadow: 1,
  padding: '$1',
  _text: {
    textAlign: 'center',
    color: 'white',
    fontFamily: 'heading',
    fontSize: 'md',
    letterSpacing: 'md',
    lineHeight: 'sm',
  },
});

export const ShortCode = Box.withConfig({
  padding: spacing.$1_5,
  _text: {
    textAlign: 'center',
    color: 'white',
    fontFamily: 'heading',
    fontSize: '4xl',
    letterSpacing: 'lg',
    lineHeight: 'sm',
    fontWeight: 'bold',
  },
});

export const CouponTitle = Box.withConfig({
  marginTop: '$2',
  marginBottom: spacing.$1_5,
  marginX: 0,
  _text: {
    color: primitive.$bbqBrown,
    textAlign: 'center',
  },
});

export const Name = BlockRenderer.withConfig({
  textProps: {
    textAlign: 'center',
    textTransform: 'uppercase',
    lineHeight: 'xs',
    fontSize: {
      base: '4xl',
      md: '3xl',
    },
    fontFamily: 'heading',
    fontWeight: 'bold',
  },
});

export const Description = BlockRenderer.withConfig({
  textProps: {
    textAlign: 'center',
    color: primitive.$bbqBrown,
    fontSize: {
      base: 'lg',
      md: 'xl',
    },
  },
});

export const Directions = Center.withConfig({
  marginTop: '$4',
});

export const RedeemInNext = withTypography({
  fontSize: 'lg',
  bold: true,
  color: primitive.$bbqBrown,
  mb: '$1',
});

export const UseCodeAtCashier = withTypography({
  mt: '$4',
  mx: '$0',
  color: primitive.$bbqBrown,
  bold: true,
  fontSize: 'lg',
  textAlign: 'center',
  style: { marginBottom: spacing.$1_5 },
});
